const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_WEB_CLIENT_ID,
      region: import.meta.env.VITE_AWS_REGION,
      loginWith: {
        oauth: {
          domain: `${import.meta.env.VITE_AWS_DOMAIN}`,
          scopes: [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin",
          ],
          redirectSignIn: ["https://www.getdaleel.com/profile"],
          redirectSignOut: ["https://www.getdaleel.com/"],
          responseType: "code" as const,
          clientId: import.meta.env.VITE_AWS_USER_POOL_WEB_CLIENT_ID,
        },
      },
    },
  },
};

export default awsConfig;
